import { render, staticRenderFns } from "./TasksPostForm.vue?vue&type=template&id=3f413351&scoped=true&"
import script from "./TasksPostForm.vue?vue&type=script&lang=ts&"
export * from "./TasksPostForm.vue?vue&type=script&lang=ts&"
import style0 from "./TasksPostForm.vue?vue&type=style&index=0&id=3f413351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f413351",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
